import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { get } from "lodash";
import { dateFormatWithTime } from "../../helper";
import { Link } from "react-router-dom";
import { PATHS } from "../../constant";
import PermissionHOC from "../PermissionHOC";
import { getLocalstorage } from "../../../src/helper";

// readAgenda

class UpcomingMOM extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { momDesc, meetingDecisionDTOS, permission } = this.props;
    const userInfo = getLocalstorage("user");
    const isUserPMG = get(userInfo, "groupCategory") === "PMG";
    const isStatePMG = get(userInfo, "groupCategory") === "STATE_PMG";

    let from =
      (get(meetingDecisionDTOS, "time") &&
        dateFormatWithTime(meetingDecisionDTOS.time)) ||
      "NA";
    /*let to =
      (get(meetingDecisionDTOS, "time") &&
        dateFormatWithTime(meetingDecisionDTOS.time)) ||
      "NA";*/

    let meetingOm = get(meetingDecisionDTOS, "fileDTOList", []);
    // meetingOm = [
    //   {
    //     "id": 13954,
    //     "title": 'It is a long established ',
    //     "mineType": "image/png",
    //     "name": "2024-03-02_14h07_59.png",
    //     "s3Url": "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/1710738470969-2024-03-02_14h07_59.png",
    //     "s3FileName": null
    //   }
    // ]
    let attachmentTitle = "";
    let extension;
    if (meetingOm.length > 0) {
      extension = meetingOm[0].name.substr(
        meetingOm[0].name.lastIndexOf(".") + 1,
        meetingOm[0].name.length
      );
      let omTitle = meetingOm[0].title;
      let omName = meetingOm[0].name;
      if (omTitle !== null) {
        //attachmentTitle = omTitle.length > 57 ? omTitle.substring(0, 57) + "..." : omTitle;
        attachmentTitle = omTitle;
      } else {
        //attachmentTitle = omName.length > 57 ? omName.substring(0, 57) + "..." : omName;
        attachmentTitle = omName;
      }
    }

    console.log(
      "meetingDecisionDTOS=========================",
      meetingDecisionDTOS
    );
    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <Col lg={momDesc ? 6 : 12}>
              <div className="mom know-mom">
                {isUserPMG || isStatePMG ? (
                  <Link
                    to={{
                      pathname: PATHS.AGENDA_DETAILS,
                      search: `?agendaId=${get(
                        meetingDecisionDTOS,
                        "id",
                        "NA"
                      )}`,
                      state: { agendaId: get(meetingDecisionDTOS, "id") }
                    }}
                  >
                    <h3>{get(meetingDecisionDTOS, "meetingName", [])}</h3>
                  </Link>
                ) : (
                  <h3>{get(meetingDecisionDTOS, "meetingName", [])}</h3>
                )}

                <div className="meeting-info meeting-when">
                  <span>
                    When: <label>{from}</label>
                  </span>
                </div>
                {/* <div className="meeting-info meeting-venue">
                  <span>
                    Venue: <label>{get(meetingDecisionDTOS, "venue", [])}</label>
                  </span>
                </div> */}
                <div className="meeting-info meeting-om">
                  <span>Meeting OM: </span>
                  <label class="meeting-om-attachment">
                    {meetingOm.length === 0 ? (
                      "-"
                    ) : (
                      <>
                        <a
                          className="om_attachment_link"
                          target="_blank"
                          href={meetingOm[0].s3Url}
                        >
                          {attachmentTitle}
                        </a>
                        <div class="attachment-added-tooltip-om">
                          <div class="project-download-icons">
                            <div class="download-icons-pdf">{extension}</div>
                            <a
                              target="_blank"
                              href={meetingOm[0].s3Url}
                              download={meetingOm[0].title || meetingOm[0].name}
                              rel="noopener noreferrer"
                            >
                              {meetingOm[0].title || meetingOm[0].name}
                            </a>
                          </div>
                        </div>
                      </>
                    )}
                  </label>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default PermissionHOC(UpcomingMOM);
